import './chunk-17755bd7.js';
import './chunk-5160dcda.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { F as Field } from './chunk-fec43884.js';
export { F as Field } from './chunk-fec43884.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Field);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/field.js
// module id = 232
// module chunks = 0